export const insightsMutationTypes = {
  FANBASE_EVOLUTION_INSIGHTS: 'FANBASE_EVOLUTION_INSIGHTS',
  INTERACTIONS_OVER_TIME_INSIGHTS: 'INTERACTIONS_OVER_TIME_INSIGHTS',
};
